// Query params that only change in-page UI state and are tracked by dedicated GA4 events.
const QUERY_ONLY_PARAMS_BY_PREFIX = [
  {
    pathPrefix: '/property/',
    params: ['active_tab'], // → property_lookup_select_table
  },
]

export const normalizePagePath = path => {
  if (!path) return ''
  const [pathname, ...searchParts] = path.split('?')
  const search = searchParts.length ? `?${searchParts.join('?')}` : ''
  return pathname + search
}

const getIgnoredQueryParams = pathname => {
  const match = QUERY_ONLY_PARAMS_BY_PREFIX.find(entry => pathname.startsWith(entry.pathPrefix))
  return match ? match.params : []
}

export const isQueryOnlyParamChange = (prevPath, nextPath) => {
  const prev = normalizePagePath(prevPath)
  const next = normalizePagePath(nextPath)
  const [prevPathname, prevSearch = ''] = prev.split('?')
  const [nextPathname, nextSearch = ''] = next.split('?')

  if (prevPathname !== nextPathname) return false

  const ignoredParams = getIgnoredQueryParams(nextPathname)
  if (!ignoredParams.length) return false

  const prevParams = new URLSearchParams(prevSearch)
  const nextParams = new URLSearchParams(nextSearch)

  let ignoredParamChanged = false
  ignoredParams.forEach(param => {
    if (prevParams.get(param) !== nextParams.get(param)) {
      ignoredParamChanged = true
    }
    prevParams.delete(param)
    nextParams.delete(param)
  })

  return ignoredParamChanged && prevParams.toString() === nextParams.toString()
}

export const shouldSkipPageView = (prevPath, nextPath) => {
  const prev = normalizePagePath(prevPath)
  const next = normalizePagePath(nextPath)

  if (!next) return true
  if (prev === next) return true
  if (prev && isQueryOnlyParamChange(prev, next)) return true

  return false
}
